<template>
  <div class="whitespace-no-wrap">
    <div class="flex items-center">
      <div v-if="date" class="user-datetime">
        <div class="system-users-date">
          {{ date | moment('MMMM D, YYYY') }}
        </div>

        <div class="system-user-hours">
          {{ date | moment('HH:mm') }}
        </div>
      </div>
      <div v-else>
        <div> - </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      date: null
    }
  },
  beforeMount () {
    if (!this.params.data) {
      return
    }

    if (this.params.column.colId === 'created_at') {
      this.date = this.params.data.created_at
    } else {
      this.date = this.params.data.last_login_at
    }
  }
}
</script>

<style scoped>
  .user-datetime {
    line-height: 20px !important;
    margin-top: 7px;
  }

  .system-user-hours {
    margin-top: 0 !important;
  }

  .system-users-date {
    font-weight: 600 !important;
  }
</style>